import { websiteGraphqlRequest } from "./websiteGraphql";
import {
    WEBSITE_QUERY_SUGGESTED_FRIENDS,
    WEBSITE_QUERY_SUGGESTED_TEAMS,
} from "../graphql/websiteQueries";
import { relayGlobalIdToDbId } from "../helpers/graphql";

const SUGGEST_FIRST = 50;

export function gqlSuggestedFriendNodeToRest(node, viewerUserId) {
    if (!node) return null;
    const uid = node.user?.userId != null ? Number(node.user.userId) : null;
    if (viewerUserId != null && uid === Number(viewerUserId)) return null;
    return {
        fullName: node.fullName || "",
        username: node.username || "",
        userPhoto: node.avatarUrl || "",
        userid: uid,
        isOwner: false,
        isSecure: false,
        infos: {
            country: node.country || "",
            skill: node.skills || "",
            job: node.jobTitle || "",
        },
    };
}

export function gqlSuggestedTeamNodeToRest(node) {
    if (!node) return null;
    const tid = relayGlobalIdToDbId(node.id) ?? 0;
    return {
        TeamName: node.name || "",
        TeamLogo: node.logoUrl || "",
        TeamDescription: node.description || "",
        teamid: tid,
        interset: node.interests || "",
    };
}

export async function fetchSuggestedFriendsPageGraphql(token, after = null) {
    const data = await websiteGraphqlRequest(
        WEBSITE_QUERY_SUGGESTED_FRIENDS,
        { first: SUGGEST_FIRST, after },
        token,
    );
    const conn = data && data.suggestedFriends;
    const viewerId = data?.me?.userId;
    if (!conn) {
        return { rows: [], pageInfo: { hasNextPage: false, endCursor: null } };
    }
    const rows = [];
    (conn.edges || []).forEach(({ node }) => {
        const row = gqlSuggestedFriendNodeToRest(node, viewerId);
        if (row) rows.push(row);
    });
    const pi = conn.pageInfo || {};
    return {
        rows,
        pageInfo: {
            hasNextPage: !!pi.hasNextPage,
            endCursor: pi.endCursor || null,
        },
    };
}

export async function fetchSuggestedTeamsPageGraphql(token, after = null) {
    const data = await websiteGraphqlRequest(
        WEBSITE_QUERY_SUGGESTED_TEAMS,
        { first: SUGGEST_FIRST, after },
        token,
    );
    const conn = data && data.suggestedTeams;
    if (!conn) {
        return { rows: [], pageInfo: { hasNextPage: false, endCursor: null } };
    }
    const rows = [];
    (conn.edges || []).forEach(({ node }) => {
        const row = gqlSuggestedTeamNodeToRest(node);
        if (row) rows.push(row);
    });
    const pi = conn.pageInfo || {};
    return {
        rows,
        pageInfo: {
            hasNextPage: !!pi.hasNextPage,
            endCursor: pi.endCursor || null,
        },
    };
}

const CORE_QUERY_FOLLOW_SUGGESTIONS = `
  query CoreFollowSuggestions($source: String) {
    followSuggestions(source: $source) {
      userId
      username
      fullName
      avatarUrl
      jobTitle
      isVerified
      isOwner
      followersCount
      isFriend
      friendRequestSent
    }
  }
`;

/** Legacy `suggestFollow/` / `myContacts/` row shape. `isfriend`: true | false | "sent". */
export function mapFollowSuggestionToRest(row) {
    return {
        userid: row.userId,
        username: row.username,
        fullName: row.fullName,
        userPhoto: row.avatarUrl,
        isOwner: !!row.isOwner,
        isSecure: !!row.isVerified,
        isfriend: row.isFriend ? true : row.friendRequestSent ? "sent" : false,
        infos: { job: row.jobTitle || "", followers: row.followersCount || 0 },
    };
}

/** @param {"people"|"contacts"} source */
export async function fetchFollowSuggestions(token, source) {
    const data = await websiteGraphqlRequest(CORE_QUERY_FOLLOW_SUGGESTIONS, { source }, token);
    return (data?.followSuggestions || []).map(mapFollowSuggestionToRest);
}
